import { Route, Switch, Redirect } from 'react-router-dom';
import { DefaultLayout } from './modules/layout/components/DefautLayout';
import { PageNotFound } from './modules/router/components/PageNotFound';
import { CurrentTheme } from './modules/themes/types';
import { MarketRoutes, MarketRoutesConfig } from './modules/Index/Routes';

export function Routes() {
  return (
    <Switch>
      <Route
        exact
        path="/"
        render={() => <Redirect to={MarketRoutesConfig.INDEX.path} />}
      />
      <Route
        exact
        path={MarketRoutesConfig.INDEX.path}
        render={() => (
          <DefaultLayout headerTheme={CurrentTheme}>
            <MarketRoutes />
          </DefaultLayout>
        )}
      />



      <Route
        render={() => (
          <DefaultLayout headerTheme={CurrentTheme}>
            <PageNotFound />
          </DefaultLayout>
        )}
      />
    </Switch>
  );
}
